import Api from "lib/api/httpRequestHelper";

import buildPrePedidosQueryParams from "./buildPrePedidosQueryParams";
import {
  PRE_PEDIDOS_EXPORT_DETAIL_CONCURRENCY,
  PRE_PEDIDOS_EXPORT_MAX,
  PRE_PEDIDOS_EXPORT_PAGE_SIZE,
} from "./pre-pedidos-export-constants";

async function fetchPrePedidosPage(filters, page, pageSize) {
  const params = buildPrePedidosQueryParams(filters, { page, pageSize });
  const response = await Api.get(
    "virtual-showcase-b2b-list-pre-pedidos",
    "showcaseB2B",
    `?${params.toString()}`,
    true,
  );
  const result = response?.Result;
  const pedidos = result?.Pedidos || result?.pedidos || [];
  return {
    pedidos: Array.isArray(pedidos) ? pedidos : [],
    totalRegistro: result?.TotalRegistro ?? 0,
  };
}

export async function fetchPrePedidoDetalhe(idPedido) {
  const response = await Api.get(
    "virtual-showcase-b2b-pre-pedido-detalhe",
    "showcaseB2B",
    `?idVitrineVirtualB2bPedido=${idPedido}`,
    true,
  );
  return response?.Result || null;
}

async function mapWithConcurrency(items, concurrency, mapper) {
  const results = [];
  for (let i = 0; i < items.length; i += concurrency) {
    const chunk = items.slice(i, i + concurrency);
    const chunkResults = await Promise.all(chunk.map(mapper));
    results.push(...chunkResults);
  }
  return results;
}

/**
 * Lista todos os pré-pedidos do filtro (paginado) e carrega detalhes para planilha de itens.
 */
export default async function fetchPrePedidosForExport(filters, { onProgress } = {}) {
  const allPedidos = [];
  let totalRegistro = 0;
  let page = 0;

  while (allPedidos.length < PRE_PEDIDOS_EXPORT_MAX) {
    onProgress?.({
      phase: "list",
      loaded: allPedidos.length,
      total: totalRegistro || null,
    });

    const { pedidos, totalRegistro: total } = await fetchPrePedidosPage(
      filters,
      page,
      PRE_PEDIDOS_EXPORT_PAGE_SIZE,
    );
    totalRegistro = total;

    if (pedidos.length === 0) break;

    allPedidos.push(...pedidos);

    if (allPedidos.length >= totalRegistro) break;
    if (allPedidos.length >= PRE_PEDIDOS_EXPORT_MAX) break;

    page += 1;
    if (page > 500) break;
  }

  const pedidosExport = allPedidos.slice(0, PRE_PEDIDOS_EXPORT_MAX);
  const truncated = totalRegistro > PRE_PEDIDOS_EXPORT_MAX;

  const ids = pedidosExport
    .map((p) => p.IdVitrineVirtualB2bPedido ?? p.idVitrineVirtualB2bPedido)
    .filter((id) => id != null);

  let done = 0;
  const detalhes = await mapWithConcurrency(
    ids,
    PRE_PEDIDOS_EXPORT_DETAIL_CONCURRENCY,
    async (id) => {
      try {
        const detalhe = await fetchPrePedidoDetalhe(id);
        done += 1;
        onProgress?.({
          phase: "details",
          loaded: done,
          total: ids.length,
        });
        return detalhe;
      } catch {
        done += 1;
        onProgress?.({
          phase: "details",
          loaded: done,
          total: ids.length,
        });
        return null;
      }
    },
  );

  return {
    pedidos: pedidosExport,
    detalhes: detalhes.filter(Boolean),
    totalRegistro,
    truncated,
  };
}
